/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import WeekDays from '@/model/dataLayer/api/common/WeekDays'
import DiscountRules from './DiscountRules'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    header: false,
    form: false,
    formConfig: {
      requiredNew: false
    }
  },

  discountRuleId: {
    displayName: 'discountRule', // 折扣规则
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: DiscountRules.getList,
        itemText: 'name'
      },
      editable: false

    }

  },

  fromTime: {
    type: IKDataEntity.Types.Time,
    displayName: 'startTime', // 开始时间
    editable: false
  },
  toTime: {
    type: IKDataEntity.Types.Time,
    displayName: 'endTime', // 结束时间
    editable: false
  },
  dayOfWeek: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: WeekDays.getList(),
        itemText: 'name'
      },
      editable: false
    }

  }
}

const config = {

  load: async function (filter) {
    return ((await hillo.get('Route.php?op=discountTimeList',
      ...filter
    )).content)
  },

  add: async function (items) {
    return await hillo.post('Route.php?op=discountTimeAdd', {
      ...items
    })
  },

  remove: function (id) {
    return hillo.post('Route.php?op=discountTimeDelete', { id })
  },

  edit: function (item) {
    return hillo.postWithUploadFile('Route.php?op=discountTimeUpdate', item, {
      showLoading: true
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
